import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from 'react-phone-number-input';
import { NavLink } from 'react-router';
import RcLink from '../../RcLink/RcLink';
import ShowStatus from '../ShowStatus/ShowStatus';

const NOT_AVAILABLE = 'Not Available';

function ShowCustomerUsersDetails({ user, showTypeLabel = false }) {
  return (
    <li
      key={user.id}
      className="flex items-center justify-between gap-x-6 py-4"
    >
      <div className="min-w-0">
        <div className="flex items-start gap-x-3">
          <p className="font-semibold text-black text-sm leading-6">
            {user.firstName} {user.lastName}
          </p>
          {showTypeLabel && <ShowStatus state="Customer" size="small" />}
        </div>
        <div className="mt-1 flex flex-col items-start gap-x-2 text-black/70 text-xs leading-5">
          <p className="whitespace-nowrap">
            Email:&nbsp;
            {user.email ? (
              <RcLink
                href={`mailto: ${user.email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {user.email}
              </RcLink>
            ) : (
              NOT_AVAILABLE
            )}
          </p>
          <p className="whitespace-nowrap">
            Phone:&nbsp;
            {user.phone ? (
              <RcLink
                href={`tel: ${user.phone}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {formatPhoneNumber(user.phone)}
              </RcLink>
            ) : (
              NOT_AVAILABLE
            )}
          </p>
        </div>
      </div>
      <div className="flex flex-none items-center gap-x-4">
        <Menu as="div" className="relative flex-none">
          <MenuButton className="-m-2.5 block p-2.5 text-black/70 hover:text-black">
            <span className="sr-only">Open options</span>
            <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
          </MenuButton>
          <Transition
            as="div"
            className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-black py-2 shadow-lg ring-1 ring-gray-900/5 transition duration-100 ease-out focus:outline-hidden data-closed:scale-95 data-enter:scale-100 data-leave:scale-95 data-closed:opacity-0 data-enter:opacity-100 data-leave:opacity-0"
          >
            <MenuItems>
              <MenuItem>
                <NavLink
                  to={`/customers/users/${user?.id}`}
                  className="block px-3 py-1 text-sm text-white leading-6"
                >
                  View
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  to={`/customers/users/${user?.id}/edit`}
                  className="block px-3 py-1 text-sm text-white leading-6"
                >
                  Edit
                </NavLink>
              </MenuItem>
            </MenuItems>
          </Transition>
        </Menu>
      </div>
    </li>
  );
}

ShowCustomerUsersDetails.propTypes = {
  user: PropTypes.object.isRequired,
  showTypeLabel: PropTypes.bool,
};

export default ShowCustomerUsersDetails;
